import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "station-list-widget" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_station_list = _resolveComponent("station-list")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_group_list = _resolveComponent("group-list")!
  const _component_n_tabs = _resolveComponent("n-tabs")!
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    class: "is-clipped",
    padding: true,
    widget: _ctx.widget,
    empty: !_ctx.stations,
    mode: _ctx.widgetMode,
    isHoverable: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_n_tabs, {
          class: "h-100",
          type: "line",
          size: "large",
          "justify-content": "space-evenly",
          "pane-class": "h-90",
          "default-value": "my-station"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_tab_pane, {
              name: "my-station",
              tab: _ctx.$t('global.stations')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_station_list, {
                  stations: _ctx.stationList || [],
                  selected: _ctx.station ? [_ctx.station] : [],
                  onStationListForget: _ctx.onStationForgotten
                }, null, 8 /* PROPS */, ["stations", "selected", "onStationListForget"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["tab"]),
            (_ctx.groups && _ctx.groups.length)
              ? (_openBlock(), _createBlock(_component_n_tab_pane, {
                  key: 0,
                  name: "groups",
                  tab: _ctx.$t('global.groups')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_group_list, {
                      groups: _ctx.groups,
                      current: _ctx.station,
                      "onStation:edit": _ctx.refresh
                    }, null, 8 /* PROPS */, ["groups", "current", "onStation:edit"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["tab"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "empty", "mode"]))
}